import moment from 'moment'
import { fetchAccountBalance } from '../../actions';
import { getCurrentTimeWithCurrentTimezone } from '../../../../../../utils';

export const submitAddBalanceForm = () => {
  return(dispatch, getState) => {
    const state = getState()
    const { name } = state.organization
    const { id } = state.resident
    const { amount, memo, payment_source, receipt_email } = state.addBalanceForm
    
    function getPaymentMethod(){
      switch(payment_source.kind){
        case 'card':
        case 'bank_account':
          return 'online'
        default:
          return payment_source.kind
      }
    }

    function getPaymentSource(){
      if(payment_source.kind === 'card' || payment_source.kind === 'bank_account'){
        return payment_source.id
      } else {
        return undefined
      }
    }

    $.ajax({
      url: `/organizations/${name}/residents/${id}/charges.json`,
      method: 'POST',
      data: { charge : {
        paid_at: moment().format('YYYY-MM-DD'), 
        amount,
        kind: 'credit',
        description: memo,
        resident_id: id,
        receipt_email: receipt_email,
        payment_method: getPaymentMethod(),
        payment_source_id: getPaymentSource()
      }},
      success: () => {
        dispatch(fetchAccountBalance())
        dispatch({type: 'SUCCESS_SUBMIT_ADD_BALANCE'})
        const nowWithTimezone = getCurrentTimeWithCurrentTimezone()
        dispatch({ type: "UPDATE_RESIDENT_UPDATED_AT", 
          payload: { resident_updated_at: nowWithTimezone }});
      },
      error: xhr => {
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({type: 'FAILED_SUBMIT_ADD_BALANCE', payload: errors })
      }
    })
  }
}

export const updateAddBalanceField = (payload) => {
  return {
    type: 'UPDATE_ADD_BALANCE_FIELD',
    payload
  }
}